<div class="h-screen w-screen flex flex-col gap-3 justify-center items-center p-3">
  <h1 class="text-[1.1rem] md:text-[1.4rem]">
    The page you are looking for can't be found
  </h1>
  <h1 class="text-[9rem] md:text-[15rem]">404</h1>
  <a [routerLink]="redirectRoute" class="bg-[#FE6313] text-white px-10 py-3">Go back home</a>
</div>
